import React from 'react';

/** Derive up to two uppercase initials from a display name (handles RTL names). */
export function initialsOf(name: string | undefined | null): string {
  const n = (name ?? '').trim();
  if (!n) return '?';
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Stable brand-ish gradient derived from a seed string (name/id). */
export function avatarGradient(seed: string | undefined | null): string {
  const palette = [
    ['#1E6BD8', '#16C2C9'],
    ['#8B5CF6', '#1E6BD8'],
    ['#16A86B', '#16C2C9'],
    ['#E8923B', '#E05260'],
    ['#3B82C4', '#16C2C9'],
    ['#E05260', '#8B5CF6'],
  ];
  const s = seed ?? '';
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  const [a, b] = palette[hash % palette.length];
  return `linear-gradient(135deg, ${a}, ${b})`;
}

export interface AvatarProps {
  name?: string | null;
  seed?: string | null;
  size?: number;
  background?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

/** Circular initials avatar used across the console (rail, rows, cards). */
export function Avatar({ name, seed, size = 34, background, className = '', style = {}, children }: AvatarProps) {
  return (
    <div
      className={'ac-avatar ' + className}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
        background: background ?? avatarGradient(seed ?? name),
        ...style,
      }}
    >
      {initialsOf(name)}
      {children}
    </div>
  );
}
